import { render, staticRenderFns } from "./ClickLogs.vue?vue&type=template&id=240f434b&"
import script from "./ClickLogs.vue?vue&type=script&lang=js&"
export * from "./ClickLogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports